import { combineReducers } from 'redux';
import sessionReducer from './sessionReducer';
import userDataReducer from './userDataReducer';
import globalRecordingReducer from './currentRecording';
import snackbarReducer from './snackbarReducer';
import userReducer from '../userSlice';

const rootReducer = combineReducers({
  sessionDetail: sessionReducer,
  userDetails: userDataReducer,
  currentMeetingDetails: globalRecordingReducer,
  snackbarReducer: snackbarReducer,
  user: userReducer,
});

export default rootReducer;
